import { getFlowTotal } from "@/config/flow-steps";

import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useFormData } from "@/stores/formStore";
import { usePageMeta } from "@/context/PageMetaContext";
import IndexForm from "@/components/ink-insanity/IndexForm";
import SEO from "@/components/ink-insanity/SEO";

const Index = () => {
  const { formData, setCurrentStep, setEra } = useFormData();
  const { setMeta } = usePageMeta();
  const { t } = useTranslation("flow");

  useEffect(() => {
    if (formData.era !== "1920s") setEra("1920s");
    setCurrentStep(1);
    setMeta({
      title: t("details.title"),
      subtitle: t("details.subtitle"),
      currentPage: 1,
      totalPages: getFlowTotal(!!formData.pulpMode),
      titleTooltip: t("details.tooltip"),
      headerContent: undefined,
    });
  }, [t, formData.pulpMode]);

  return (
    <>
      <SEO title={t("details.seoTitle")} description={t("details.seoDescription")} path="/1920s" />
      <IndexForm />
    </>
  );
};

export default Index;
